import { Text } from '@chakra-ui/react';
import { selectedDatabaseIdState, useIsUserInRole } from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';
import Widget from './Widget';
import { useNetworkAvailabilityKPI } from '../../context/reports-api-hooks';
import { CircleIndicator } from '../indicators';
import { roundKpiValue } from '../../shared/helpers';

export default function NetworkAvailabilityAccessibilityWidget() {
  const rcaId = useRecoilValue(selectedDatabaseIdState);
  const { data: networkAvailabilityData, isLoading, isError } = useNetworkAvailabilityKPI();
  const hasDeveloperRole = useIsUserInRole('Developer');

  const title = 'Network Availability\n& Accessibility';
  const description = 'Proportion of network accessible to\nClass 1 and 50MAX vehicles';

  // Only allow access to RCAs excluding State Highways & Doc Roads
  // unless user has Developer role
  if ((rcaId === 81 || rcaId >= 1000 || rcaId === 88) && !hasDeveloperRole) {
    return null;
  }

  // If there is an error we want to hide the widget
  if (isError) return null;

  return (
    <Widget
      link="/performance/dashboard/network-availability"
      title={title}
      description={description}
      lockYear={networkAvailabilityData?.lockYear}
      quarter={null}
      isLoading={isLoading && !networkAvailabilityData}
      moreInfoContent={
        <Text fontSize="sm">The proportion of the road network that is accessible to Class 1, 50MAX, and HPMV heavy vehicles.</Text>
      }
    >
      <CircleIndicator
        size={100}
        colour={!networkAvailabilityData?.nodata ? 'gray.700' : null}
        value={!networkAvailabilityData?.nodata ? `${roundKpiValue(networkAvailabilityData?.value, 99.5, 1, 'min')}%` : undefined}
        isLoading={isLoading || !networkAvailabilityData}
      />
    </Widget>
  );
}
